module.exports = __webpack_public_path__ + "media/vid_popup.83e1da0a.mp4";